export const getStatusTextColor = (status: string): string => {
  switch (status) {
    case "completed":
      return "text-success";
    case "in_progress":
      return "text-primary";
    default:
      return "text-destructive";
  }
};

export const getStatusBadgeClasses = (status: string): string => {
  switch (status) {
    case "pending":
    case "awaiting_payment":
      return "bg-warning/10 text-warning border border-warning/25";
    case "accepted":
    case "active":
      return "bg-success/10 text-success border border-success/30";
    case "declined":
      return "bg-destructive/10 text-destructive border border-destructive/25";
    case "cancelled":
      return "bg-muted text-muted-foreground border border-border";
    default:
      return "bg-muted text-muted-foreground border border-border";
  }
};
